module.exports = __webpack_public_path__ + "static/media/MercBClass2@2x.367a9d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/monoshift/MercBClass2@2x.jpg
// module id = 66
// module chunks = 0